import {Component, OnInit, Input} from '@angular/core';
import {ChartDataSets, ChartType, ChartOptions} from 'chart.js';
import {Label, Color} from 'ng2-charts';
import {DependencesService} from '../../services/dependences.service';
import {StatsService} from '../../services/stats.service';
import {NbAuthOAuth2JWTToken, NbAuthService} from '@nebular/auth';
const Lockr = require("lockr");
@Component({
  selector: 'ngx-stations-indicators',
  templateUrl: './stations-indicators.component.html',
  styleUrls: ['./stations-indicators.component.scss']
})
export class StationsIndicatorsComponent implements OnInit {
  @Input() userId: string;
  loading: boolean = false;
  user: {
    email: '',
    name: '',
    user_id: '',
  }

  // Pie
  public pieChartOptions: ChartOptions = {
    responsive: true,
    tooltips: {
      callbacks: {
        label: function (item, data) {
          return data.labels[item.index] + ':' + data.datasets[item.datasetIndex].data[item.index] + '%'
        }
      }
    },
    legend: {
      position: 'top',
    },
    plugins: {
      datalabels: {
        formatter: (value, ctx) => {
          const label = ctx.chart.data.labels[ctx.dataIndex];
          return label;
        },
      },
    }
  };
  public pieChartLabels: Label[] = [];
  public pieChartData: number[] = [];
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartColors = [
    {
      backgroundColor: [
        'rgba(9,157,132,0.7)',
        'rgba(77,157,179,0.7)',
        'rgba(69,106,207,0.7)',
        'rgba(135,98,201,0.7)',
        'rgba(173,24,45,0.7)',
        'rgba(225,95,95,0.7)'
      ],
    },
  ];

  // Bar
  public barChartOptions: ChartOptions = {
    responsive: true,
    tooltips: {
      callbacks: {
        title: function (item, data) {
          return data.datasets[item[0].datasetIndex].label.split(';')[item[0].index].split('-')[2]
        },
        label: function (item, data) {
          return data.datasets[item.datasetIndex].label.split(';')[item.index].split('-')[1] + ':' + item.yLabel
        }
      }
    },
    scales: {
      xAxes: [{
        stacked: true,
        scaleLabel: {
          display: true,
          labelString: 'Estaciones'
        }
      }],
      yAxes: [{
        stacked: true,
        scaleLabel: {
          display: true,
          labelString: 'Acumulado de documentos entregados'
        }
      }]
    },
    plugins: {
      datalabels: {
        anchor: 'end',
        align: 'end',
      }
    }
  };
  public barChartLabels: Label[] = [];
  public barChartType: ChartType = 'bar';
  public barChartLegend = false;
  public barChartColors: Color[] = [
    {backgroundColor: 'rgba(9,157,132,0.7)'},
    {backgroundColor: 'rgba(77,157,179,0.7)'},
    {backgroundColor: 'rgba(69,106,207,0.7)'},
    {backgroundColor: 'rgba(135,98,201,0.7)'},
    {backgroundColor: 'rgba(173,24,45,0.7)'},
    {backgroundColor: 'rgba(225,95,95,0.7)'}
  ]

  public barChartData: ChartDataSets[] = [
    {data: [], label: ''},
    {data: [], label: ''},
    {data: [], label: ''},
    {data: [], label: ''},
    {data: [], label: ''},
    {data: [], label: ''},
  ];

  constructor(
    private statsService: StatsService,
    private dependencesService: DependencesService,
    private authService: NbAuthService,
  ) {
  }

  async ngOnInit() {
    await this.getStats();
  }

  async getUserData() {
    this.user = Lockr.get('user');
  }

  async getStats() {
    this.loading = true;
    await this.getUserData();
    let stations = [];
    const [errorDependences, {data: dependences}] = await this.dependencesService.all();
    if (errorDependences) return errorDependences;
    let requirementsDelivered = 0;
    let totalRequirements = 0;
    let arrayData = [];
    const promisesRequirements = [];
    for (const dependence of dependences) {
      promisesRequirements.push(this.statsService.getStationsStats(this.user.user_id, dependence.id));
    }

    Promise.all(promisesRequirements).then(async data => {
      arrayData = data.map((el, index) => {
        this.pieChartLabels.push(dependences[index].name);
        requirementsDelivered += el[1].totalDelivered;
        totalRequirements += el[1].totalRequirements;
        stations = el[1].stations;
        return el[1].totalDelivered;
      });

      for (const value of arrayData) {
        this.pieChartData.push((value / totalRequirements) * 100);
      }
      this.pieChartData.push(((totalRequirements - requirementsDelivered) / totalRequirements) * 100);
      this.pieChartLabels.push("No entregados");

      const promisesByStation = [];
      for (const station of stations) {
        promisesByStation.push(this.statsService.getStats(station.id));
      }

      Promise.all(promisesByStation).then(dataByStations => {
        const _dataByStations = dataByStations.map(dataStation => dataStation[1].data);
        for (let i = 0; i < _dataByStations.length; i++) {
          const stats = _dataByStations[i];
          for (let z = 0; z < stats.length; z++) {
            this.barChartData[z].data.push(stats[z].total_delivered);
            this.barChartData[z].label += stations[i].acronym + '-' + stats[z].complete_name + '-' + stations[i].business_name + ';';
          }
          this.barChartLabels.push(stations[i].acronym);
        }
      });
      this.loading = false;
    });
  }

}
